module.exports = __webpack_public_path__ + "assets/img/pages/payment/privatbank.jpg?4718";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pages/payment/privatbank.jpg
// module id = 19
// module chunks = 0